export default "__VITE_ASSET__aac80242__"